import { GroupsSection } from '../../common/main/groups/GroupsSection';

export const StudentGroupsPage = () => {
  return <GroupsSection />;
};
